module.exports = __webpack_public_path__ + "img/product-1-back-INTMOBILE.a4362d2f.png";